import Cookies from 'js-cookie';
import axios from 'axios';

// Verifica token e, se válido, exibe botão de edição no portal público
export async function maybeShowEditArticleButton() {
  const mountPoint = document.getElementById('edit-article-entrypoint');
  if (!mountPoint) return;

  const editUrl = mountPoint.dataset.editUrl;
  const raw = Cookies.get('cw_d_session_info');
  if (!raw) return; // sem cookie = não logado

  let headers;
  try {
    headers = JSON.parse(raw);
  } catch (e) {
    return; // cookie inválido
  }

  try {
    await axios.get('/auth/validate_token', {
      headers: {
        'access-token': headers['access-token'],
        client: headers.client,
        uid: headers.uid,
        expiry: headers.expiry,
        'token-type': headers['token-type'] || headers.token_type,
      },
    });
    renderButton(mountPoint, editUrl);
  } catch (e) {
    // token inválido ou expirado: silenciosamente não mostra o botão
  }
}

// Exibe também portais não públicos na barra de portais relacionados se usuário autenticado
export async function maybeExpandRelatedPortals() {
  const container = document.getElementById('related-portals');
  if (!container) return; // não está na página inicial do portal

  const raw = Cookies.get('cw_d_session_info');
  if (!raw) return; // sem cookie => não tenta

  let headers;
  try {
    headers = JSON.parse(raw);
  } catch (e) {
    return;
  }

  // valida token primeiro
  try {
    await axios.get('/auth/validate_token', {
      headers: {
        'access-token': headers['access-token'],
        client: headers['client'],
        uid: headers['uid'],
        expiry: headers['expiry'],
        'token-type': headers['token-type'] || headers['token_type'],
      },
    });
  } catch (_) {
    return; // token inválido
  }

  // busca todos os portais da conta via API interna autenticada
  const accountId = container.dataset.accountId;
  if (!accountId) return;

  try {
    const resp = await axios.get(`/api/v1/accounts/${accountId}/portals.json`, {
      headers: {
        'access-token': headers['access-token'],
        client: headers.client,
        uid: headers.uid,
        expiry: headers.expiry,
        'token-type': headers['token-type'] || headers.token_type,
      },
    });
    const currentPortalId = parseInt(container.dataset.currentPortalId, 10);
    const existingSlugs = new Set(
      Array.from(container.querySelectorAll('a')).map(a =>
        a.getAttribute('href')
      )
    );
    resp.data.payload
      .filter(p => !p.archived) // ignora arquivados
      .forEach(p => {
        const href = `/hc/${p.slug}`;
        if (existingSlugs.has(href)) return;
        // acrescentar somente se era privado (is_public == false) para não duplicar
        if (p.is_public) return;
        const a = document.createElement('a');
        a.href = href;
        a.className = `text-sm ${
          p.id === currentPortalId
            ? 'text-slate-800 dark:text-slate-100 font-semibold'
            : 'text-slate-500 hover:cursor-pointer font-semibold'
        }`;
        a.textContent = p.name;
        container.appendChild(a);
      });
  } catch (e) {
    // silêncio em erro
  }
}

function editIconSVG() {
  // Inline SVG com stroke herdando currentColor para adaptar a temas
  return `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.2 2.4L13.6 4.8" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M3 13L4.3 8.9C4.37 8.67 4.5 8.46 4.67 8.29L10.73 2.23C10.9172 2.04273 11.1705 1.9375 11.435 1.9375C11.6995 1.9375 11.9528 2.04273 12.14 2.23L13.37 3.46C13.5573 3.64716 13.6625 3.90054 13.6625 4.165C13.6625 4.42946 13.5573 4.68284 13.37 4.87L7.31 10.93C7.14 11.1 6.93 11.23 6.7 11.3L3 13Z" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  `;
}

function renderButton(container, editUrl) {
  container.classList.remove('hidden');
  const label = container.dataset.editLabel || 'Edit this article';
  container.innerHTML = `
    <a
      href="${editUrl}"
      data-turbolinks="false"
  class="group inline-flex items-center justify-center mt-1 w-9 h-9 rounded-md border border-slate-200 dark:border-slate-700 bg-slate-100 bg-opacity-95 dark:bg-slate-800 text-slate-500 dark:text-slate-300 stroke-slate-500 dark:stroke-slate-300 hover:bg-slate-200 dark:hover:bg-slate-700 hover:text-slate-700 hover:stroke-slate-700 dark:hover:text-slate-100 dark:hover:stroke-slate-100 transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-slate-300 dark:focus:ring-slate-600"
      aria-label="${label}"
      title="${label}"
    >
      <span class="w-4 h-4 [&>svg]:w-4 [&>svg]:h-4 stroke-current">${editIconSVG()}</span>
    </a>
  `;
}
